import React from 'react'

import {
  $DCprimaryColor,
  PixelAlert,
  PixelCollapse,
  PixelCurrency,
  colors,
} from 'pixel-base'
import styled from 'styled-components'
import ChevronDownIcon from 'utils/icons/chevron-down-icon'
import ChevronUpIcon from 'utils/icons/chevron-up-icon'
const tenant_info: any = JSON.parse(localStorage.getItem('tenant_info') || '{}')

const CollapseAbleCard = (props) => {
  const {
    mainDec,
    variant,
    title,
    totalCount,
    isCOD,
    COD,
    CODDec,
    countINCurrency,
    extraLines,
    style,
    logo,
  } = props
  const [isExpanded, setExpanded] = React.useState(false)
  const handleToggle = () => {
    setExpanded(!isExpanded)
  }
  return (
    <StatsCard style={style} variant={variant}>
      <StatsItemTitle>
        <CourierLogo src={logo} />
        &nbsp;{title}
      </StatsItemTitle>
      <StatsItemContainer>
        <StatsItemsOrders>
          <span
            style={{
              fontSize: '18px',
            }}
          >
            {isCOD ? (
              <>
                <span
                  style={{
                    fontSize: '10px',
                  }}
                >
                  {tenant_info?.default_currency_symbol}
                </span>
                <PixelCurrency hideSymbol={true} value={COD} />
              </>
            ) : (
              <span style={{ paddingLeft: '10px' }}>--</span>
            )}
          </span>
          <StatsItemCount
            style={{
              fontSize: '10px',
            }}
          >
            {CODDec || 0}
          </StatsItemCount>
        </StatsItemsOrders>

        <StatsItems>
          <OrdersCount>
            {' '}
            {countINCurrency ? (
              <PixelCurrency value={totalCount} />
            ) : (
              <>{totalCount || 0}</>
            )}
          </OrdersCount>
          <StatsItemCount>{mainDec}</StatsItemCount>
        </StatsItems>
      </StatsItemContainer>
      <PixelCollapse
        onCollapseChange={(collapse) => {
          setExpanded(collapse)
        }}
        collapseController={
          <>
            <span
              id="collapse-controller"
              className="alert"
              style={{
                padding: '0px',
                margin: '0px',
                fontSize: '10px',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
              onClick={handleToggle}
            >
              {isExpanded ? (
                <ChevronUpIcon color={$DCprimaryColor} size={18} />
              ) : (
                <ChevronDownIcon color={$DCprimaryColor} size={18} />
              )}{' '}
              &nbsp; &nbsp;
              {isExpanded ? 'Show Less' : 'Show More'}
            </span>
          </>
        }
      >
        {extraLines &&
          extraLines.map((item, index) => (
            <OtherDetail key={index}>
              <div>
                <OtherDetail>
                  {' '}
                  <span
                    style={{
                      fontSize: '13px',
                    }}
                  >
                    {item.title || 0}
                  </span>
                  <StatsItemCount
                    style={{
                      marginBottom: '2px',
                      fontSize: '10px',
                    }}
                  >
                    {item.dec}
                  </StatsItemCount>
                </OtherDetail>
              </div>
            </OtherDetail>
          ))}
      </PixelCollapse>
    </StatsCard>
  )
}

const StatsCard = styled(PixelAlert)<{ flexEnd?: boolean }>`
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 10px;
  width: 24%;
  margin: 0px;
  min-height: 90px;
`

const StatsItemTitle = styled.div`
  font-size: 14px;
  width: 100%;
  padding-bottom: 5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #000;
  margin: 0px;
`
const StatsItemCount = styled.div<{ justify?: boolean }>`
  font-size: 10px;
  font-weight: 300;
  color: #000;
  margin: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) =>
    props.justify ? 'flex-start' : 'space-between'};
  align-items: flex-start;
  align-content: center;
`
const StatsItemContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  margin-bottom: 10px;
`
const OrdersCount = styled.div`
  font-size: 30px;
  font-weight: 500;
`
const StatsItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  align-items: center;
  width: 30%;
`
const StatsItemsOrders = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-content: flex-start;
  align-items: flex-start;
  width: 70%;
`
const OtherDetail = styled.div`
  display: flex;
  font-size: 18px;
  gap: 5px;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  align-items: flex-end;
  &.isCourier {
    flex-direction: column-reverse;
    align-content: flex-start;
    gap: 0px;
    align-items: flex-start;
    > div {
      margin-bottom: -5px;
    }
    > span {
      margin-bottom: 5px;
    }
  }
`
const CourierLogo = styled.img`
  border-radius: 50%;
  width: 40px;
  height: 40px;
`

const CollapseAbleCardContainer = styled.div`
  border: 1px solid ${colors.grayBorderLight};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: ${colors.white};
`

const CollapseAbleCardTitle = styled.h3`
  color: ${colors.black};
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
`

const CollapseAbleCardDescription = styled.p`
  color: ${colors.black};
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
`

export default CollapseAbleCard
